<template>
  <div class="card p-2" style="min-height: 200px">
    <div class="table-responsive">
      <table class="table">
        <thead>
        <tr>
          <th class="text-left">Policy Name</th>
          <th class="text-center">Branch</th>
          <th class="text-center">Department</th>
          <th class="text-center">Employee</th>
          <th class="text-center">Effective Date</th>
          <th class="text-center">Status</th>
          <th>Action</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, i) in tableItems" :key="i">
          <td class="text-left"> {{ item.policy_name }}</td>
          <td class="text-center"> {{ item.branch_name }}</td>
          <td class="text-center"> {{ item.department_name }}</td>
          <td class="text-center"> {{ item.contact_profile_name }}</td>
          <td class="text-center"> {{ item.effective_date }}</td>
          <td class="text-center"> {{ item.status }}</td>
          <td>
            <button class="btn btn-primary btn-sm"
                    @click="goToEdit(item)"
                    style="cursor: pointer"
            >
              <i class="fas fa-eye"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
      <p v-if="tableItems.length < 0" class="text-center mt-5">No data</p>
    </div>
  </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";

const props  = defineProps({
  tableItems     : Object,
});
const route  = useRoute();
const router = useRouter();

const goToEdit = (item) => {
  let param = {
    companyId: route.params.companyId,
    moduleId: route.params.moduleId,
    menuId: route.params.menuId,
    pageId: route.params.pageId
  }

  let query = route.query;
  query.allocationId = item.id;

  router.push({
    name:  'attendance-policy-allocation-add',
    params: param,
    query: query
  })
}
</script>
